"use strict";
import { __exports as o } from "./index.es531.js";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _;
function g() {
  if (_) return o;
  _ = 1;
  var t = typeof Symbol == "function" && Symbol.for, p = t ? Symbol.for("react.element") : 60103, b = t ? Symbol.for("react.portal") : 60106, n = t ? Symbol.for("react.fragment") : 60107, f = t ? Symbol.for("react.strict_mode") : 60108, c = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, u = t ? Symbol.for("react.context") : 60110, $ = t ? Symbol.for("react.async_mode") : 60111, s = t ? Symbol.for("react.concurrent_mode") : 60111, i = t ? Symbol.for("react.forward_ref") : 60112, y = t ? Symbol.for("react.suspense") : 60113, C = t ? Symbol.for("react.suspense_list") : 60120, l = t ? Symbol.for("react.memo") : 60115, m = t ? Symbol.for("react.lazy") : 60116, M = t ? Symbol.for("react.block") : 60121, x = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, w = t ? Symbol.for("react.scope") : 60119;
  function e(r) {
    if (typeof r == "object" && r !== null) {
      var S = r.$$typeof;
      switch (S) {
        case p:
          switch (r = r.type, r) {
            case $:
            case s:
            case n:
            case c:
            case f:
            case y:
              return r;
            default:
              switch (r = r && r.$$typeof, r) {
                case u:
                case i:
                case m:
                case l:
                case a:
                  return r;
                default:
                  return S;
              }
          }
        case b:
          return S;
      }
    }
  }
  function d(r) {
    return e(r) === s;
  }
  return o.AsyncMode = $, o.ConcurrentMode = s, o.ContextConsumer = u, o.ContextProvider = a, o.Element = p, o.ForwardRef = i, o.Fragment = n, o.Lazy = m, o.Memo = l, o.Portal = b, o.Profiler = c, o.StrictMode = f, o.Suspense = y, o.isAsyncMode = function(r) {
    return d(r) || e(r) === $;
  }, o.isConcurrentMode = d, o.isContextConsumer = function(r) {
    return e(r) === u;
  }, o.isContextProvider = function(r) {
    return e(r) === a;
  }, o.isElement = function(r) {
    return typeof r == "object" && r !== null && r.$$typeof === p;
  }, o.isForwardRef = function(r) {
    return e(r) === i;
  }, o.isFragment = function(r) {
    return e(r) === n;
  }, o.isLazy = function(r) {
    return e(r) === m;
  }, o.isMemo = function(r) {
    return e(r) === l;
  }, o.isPortal = function(r) {
    return e(r) === b;
  }, o.isProfiler = function(r) {
    return e(r) === c;
  }, o.isStrictMode = function(r) {
    return e(r) === f;
  }, o.isSuspense = function(r) {
    return e(r) === y;
  }, o.isValidElementType = function(r) {
    return typeof r == "string" || typeof r == "function" || r === n || r === s || r === c || r === f || r === y || r === C || typeof r == "object" && r !== null && (r.$$typeof === m || r.$$typeof === l || r.$$typeof === a || r.$$typeof === u || r.$$typeof === i || r.$$typeof === x || r.$$typeof === v || r.$$typeof === w || r.$$typeof === M);
  }, o.typeOf = e, o;
}
export {
  g as __require
};
//# sourceMappingURL=index.es522.js.map
